String.prototype.toBool = function() {
    var s = this.toLowerCase().trim();
    var isBool = (s == 'true' || s == '1' || s == 'on');
    return isBool;
};

String.prototype.supplant = function (obj) {
    return this.replace(/{([^{}]*)}/g,
        function (a, b) {
            var value = obj[b];
            return typeof value === 'string' || typeof value === 'number' ? value : a;
        }
    );
};
Array.prototype.getItemInArray = function (attr, value) {
    for (var i = 0; i < this.length; i++) {
        if (this[i][attr] == value) {
            return this[i];
        }
    }
    return null;
};
Array.prototype.has = function (value) {
    var exists =  this.indexOf(value) != -1;
    return exists;
};

Array.prototype.hasKey = function (key) {
    for (var i = 0; i < this.length; i++) { 
        if (this[i].key == key) { 
            return true; 
        }
    }
    return false;
  };

  Array.prototype.getPropByKey = function (attr, key) {
    for (var i = 0; i < this.length; i++) { 
        if(this[i].key == key){
            return this[i][attr];
        }
    }
    return null;
  };

Array.prototype.getIndexOfObjInAttr = function (attr, value) {
    for (var i = 0; i < this.length; i++) {
        if (this[i][attr] == value) {
            return i;
        }
    }
    return -1;
};

Array.prototype.itemIndex = function (key) {
    
    for (var i = 0; i < this.length; i++) { 
        if (this[i].key == key) { 
            return i; 
        }
    }
    return -1;
};
Array.prototype.getKeyValueValue = function (id) {
    
    for (var i = 0; i < this.length; i++) { 
        if (this[i].id == id) { 
            return this[i].value; 
        }
    }
    return -1;
};

Array.prototype.findItem = function (prop, value) {
    return this.find(o => o[prop] === value);
};